export default __webpack_public_path__ + "assets/images/562a56ae4e565992af36f8d496e823df.mp3";